// Logica condivisa tra la tab Riepilogo e la Dashboard:
// aggregazione temporale (giornaliera/settimanale/mensile/annuale) e formattazione.

// Le 4 viste, usate per i pulsanti di aggregazione.
export const VISTE = [
  { id: "giornaliera", label: "Giornaliera" },
  { id: "settimanale", label: "Settimanale" },
  { id: "mensile",     label: "Mensile" },
  { id: "annuale",     label: "Annuale" },
];

// Campi base mediati nelle viste aggregate (le pro-capite sono derivate).
export const CAMPI_BASE = ["persone", "colli_totali_prodotti", "colli_carico_cnt", "colli_senza_pr"];

// "2026-06-01" → "Lunedì 1 giugno"
export function labelData(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  const s = dt.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// "2026-06-01" → "1/6" (etichetta compatta per l'asse x dei grafici)
export function labelDataBreve(iso) {
  const [, m, d] = iso.split("-").map(Number);
  return `${d}/${m}`;
}

export function fmt(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toLocaleString("it-IT", { maximumFractionDigits: 2 });
}

// Numero settimana ISO di una data.
export function isoWeek(dt) {
  const d = new Date(Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - dayNum + 3);
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  return 1 + Math.round(((d - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7);
}

export function meseNome(dt) {
  const s = dt.toLocaleDateString("it-IT", { month: "long" });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Aggrega le righe giornaliere per settimana/mese/anno facendo la MEDIA dei campi base.
// Ritorna righe { key, label, minData, ...campi base mediati } ordinate per data.
export function aggrega(rows, vista) {
  const groups = new Map();
  for (const r of rows) {
    const [y, m, d] = r.data.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    let key, label;
    if (vista === "settimanale") {
      const w = isoWeek(dt);
      key = `${y}-${String(m).padStart(2, "0")}-W${w}`;
      label = `Sett. ${w} · ${meseNome(dt)} ${y}`;
    } else if (vista === "mensile") {
      key = `${y}-${String(m).padStart(2, "0")}`;
      label = `${meseNome(dt)} ${y}`;
    } else { // annuale
      key = `${y}`;
      label = `${y}`;
    }
    let g = groups.get(key);
    if (!g) {
      g = { key, label, minData: r.data, count: 0, somme: {} };
      CAMPI_BASE.forEach(c => (g.somme[c] = 0));
      groups.set(key, g);
    }
    g.count += 1;
    if (r.data < g.minData) g.minData = r.data;
    CAMPI_BASE.forEach(c => (g.somme[c] += r[c] || 0));
  }
  return Array.from(groups.values())
    .sort((a, b) => (a.minData < b.minData ? -1 : 1))
    .map(g => {
      const row = { key: g.key, label: g.label, minData: g.minData };
      CAMPI_BASE.forEach(c => (row[c] = g.count > 0 ? g.somme[c] / g.count : 0));
      return row;
    });
}
